@use 'vars';

.iq-results-actions {
  display: flex;
  flex-direction: row;
  gap: vars.$gap-medium;
}
